import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { ShoppingCartService } from '../cart.service'
import { FormGroup } from '@angular/forms'
import { Item } from '../cart-item/cart-item.component'
import moment from 'moment'
import { CalenderConfigService } from '../../../../shared/services/calender-config.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,

  selector: 'vs-delivery-group-dialog',
  templateUrl: './cart-delivery-group-dialog.html',
  styleUrls: ['./cart-delivery-group-dialog.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DeliveryGroupDialogComponent implements OnInit {
  cart: any

  /* @Input()
  cartId: any; */

  userType: any

  // tslint:disable-next-line: variable-name
  _items: Item[] = []

  items: Item[]

  minDate = new Date()

  deliveryGroupForm: FormGroup
  showError = false
  errors: any = {
    type: '',
    entryNumbers: [],
  }
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  constructor(
    private launchDialogService: LaunchDialogService,
    private shoppingCartService: ShoppingCartService,
    private calenderConfigService: CalenderConfigService
  ) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.cart = data.cart
      this.items = data.items
      this.userType = data.userType
    })
    this._items = this.items.map((item) => {
      return Object.assign({}, item)
    })
  }

  closeModal(reason?: any): void {
    if (reason == 'save-delivery-groups') {
      this.errors = this.shoppingCartService.validateDeliveryGroups(this._items)
      if (this.errors) {
        this.showError = true
      } else {
        this.showError = false
        const dialogResponse: DialogResponse = {
          data: this._items,
          reason: reason,
          type: VS_LAUNCH_CALLER.DELIVERY_GROUP,
        }
        this.launchDialogService.closeDialog(dialogResponse)
      }
    } else {
      const dialogResponse: DialogResponse = {
        reason: reason,
        type: VS_LAUNCH_CALLER.DELIVERY_GROUP,
      }
      this.launchDialogService.closeDialog(dialogResponse)
    }
  }

  onDateChange(e, index) {
    this._items[index].assignedShipDate = moment(e).format('YYYY/MM/DD')
    /* this._items[index].customerRequestedDate = e.toISOString()
      .slice(0, 19)
      .replace(/-/g, '/')
      .split('T')[0]; */
  }

  isEntryHasError(index) {
    for (const e of this.errors.entryNumbers) {
      if (e == index) {
        return true
      }
    }
  }
}
